<template lang="html">
  <div
    class="other-groups"
    v-if="otherGroups.length > 0 && scrollGroups.length > 0"
  >
    <div class="head-title">
      <span class="title-name">以下小伙伴正在发起团购,快来参加吧～</span>
      <span v-if="scrollGroups.length > 2" class="watch-more" @click="watchMore"
        >更多</span
      >
    </div>
    <div class="list-box">
      <ul
        class="other-group-items"
        :class="{ openanimation: openAnimation }"
        :style="{ transform: 'translateY(-' + noticePosition + 'px) ' }"
      >
        <li class="items" v-for="item in scrollGroups">
          <div class="left">
            <div
              class="item-pic"
              :style="{
                backgroundImage: 'url(' + defaultImg(item.headUrl) + ')'
              }"
            ></div>
            <div class="user-info">
              <p class="name">
                {{ item.startName }}
              </p>
              <span class="nick-name"> 命中注定一起拼 </span>
            </div>
          </div>

          <div class="right">
            <div class="item-info">
              <p class="limit">
                还差<span>{{ item.leftNum }}</span
                >人成团
              </p>
              <span class="remain-time">
                <countDown
                  :targetTime="changeTimeFormat(item.endTime)"
                  :timeOffset="timeOffset(item.serviceTime)"
                  :simple="true"
                ></countDown>
              </span>
            </div>
            <button class="join-button" @click="joinGroup(item)">
              {{ item.hasJoinGroup == 1 ? "邀请好友" : "去参团" }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import countDown from "@/components/common/countDown";
import log from '@/store/actions/log';

let interval = ''
export default {
  data() {
    return {
      noticePosition: 0,
      animate: false,
      openAnimation: true,
      defaultHeadPic:
        '//cmspic-10004025.image.myqcloud.com/a768b960-c96c-11e9-acb6-930bdcfa27a4_size_135x135'
    }
  },
  props: {
    otherGroups: {
      type: Array
    },
    spuId: {
      type: Number,
      default: 0
    },
    skuId: {
      type: Number,
      default: 0
    },
    jumpOrderConfirm: {
      type: Function,
      default: () => {}
    },
    watchMore: {
      type: Function,
      default: () => {}
    },
    serviceTime: {
      type: Number
    }
  },
  components: {
    countDown
  },
  computed: {
    scrollGroups() {
      if (this.otherGroups.length > 2) {
        const arr = this.otherGroups.slice(0, 2)
        return this.otherGroups.concat(arr)
      } else {
        return this.otherGroups
      }
    }
  },
  methods: {
    changeTimeFormat(date) {
      // eslint-disable-next-line no-useless-escape
      return new Date(date.replace(/\-/g, '/')).getTime()
    },
    timeOffset(date) {
      return date - Date.now()
    },
    async joinGroup(item) {
      const { groupId, groupRuleId , hasJoinGroup } = item;
      if(+hasJoinGroup === 1){
        location.href = `/v/order/group/${groupId}?cmd=share&sharetype=0&refresh=no`
      }else{
        const spuId = this.spuId;
        const skuId = this.skuId;
        // 因为其余拼团列表返回的信息中没有spu和sku，所以从父组件传给他，不然没有办法跳到订单确认页
        const query = {
          skuId,
          ruleId: groupRuleId,
          ruleType: 4,
          groupId
        };
        await this.jumpOrderConfirm(spuId, query);
      }
      
    },
    autoMove() {
      interval = setInterval(() => {
        if (this.noticePosition / 76 < this.scrollGroups.length - 2) {
          this.noticePosition += 76
        } else {
          // 列表到底
          this.openAnimation = false
          this.noticePosition = 0 // 设置列表为开始位置
          setTimeout(() => {
            this.openAnimation = true
          }, 100)
        }
      }, 2000)
    },
    scroll() {
      if (this.otherGroups.length > 2) {
        this.autoMove()
      }
    },
    defaultImg(img) {
      return img || this.defaultHeadPic
    }
  },
  created() {
    this.scroll()
    console.log(this.otherGroups)
  },
  destroyed() {
    interval && window.clearInterval(interval)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.other-groups {
  margin-bottom: rem(-2px);
  padding: rem(40px) rem(30px) 0;
  background: #fff;
  border-top-left-radius: rem(8px);
  border-top-right-radius: rem(8px);

  .head-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: rem(10px);

    .title-name {
      font-size: rem(28px);
      color: #121212;
      line-height: rem(32px);
    }

    .watch-more {
      font-size: rem(24px);
      color: #999999;
      line-height: rem(28px);
      padding-bottom: rem(2px);
    }
  }

  .list-box {
    max-height: rem(304px);
    overflow: hidden;
  }
  .other-group-items {
    .items {
      padding: rem(30px) 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      &::after {
        content: '';
        width: rem(1300px);
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        border-bottom: 1px solid #ebebeb;
        transform-origin: 0 0;
        transform: scale(0.5);
      }
      .left,
      .right {
        display: flex;
        align-items: center;
      }

      .item-pic,
      .item-pic::after {
        width: rem(64px);
        height: rem(64px);
        border-radius: 50%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .user-info {
        display: flex;
        flex-direction: column;
        margin-left: rem(16px);
        margin-right: rem(20px);
        .name {
          font-size: rem(26px);
          max-width: rem(250px);
          color: #121212;
          @include ellicpsis;
        }
        .nick-name {
          margin-top: rem(4px);
          font-size: rem(22px);
          line-height: rem(28px);
          color: #999;
        }
      }

      .item-info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .limit {
          font-size: rem(26px);
          color: #121212;
          line-height: rem(34px);

          span {
            color: #ff5900;
          }
        }
        .remain-time {
          font-size: rem(22px);
          color: #999;
        }
      }

      .join-button {
        margin-left: rem(15px);
        width: rem(120px);
        min-width: rem(120px);
        height: rem(48px);
        justify-self: flex-end;
        background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
        border-radius: rem(50px);
        color: #fff;
        font-size: rem(24px);
        line-height: rem(48px);
      }
    }
  }
  .other-group-items.openanimation {
    transition-duration: 2s;
  }
}
</style>
